module.exports = __webpack_public_path__ + "img/select-3-3.009076b2.png";